import React, { useState } from "react";
import { Field, Button } from "@fluentui/react-components";
import { useTaskPane } from "../../provider/TaskPaneProvider";
import services from "../../services/indexService";
import useToast from "../../hooks/useToast";
import AlertPopup from "./AlertPopup";
import { appInsights } from "../../../telemetry/telemetryService";

const SearchCriteria = ({ updateState, clearToaster }) => {
  const appVersion = process.env.AppVersion;
  const {
    locationData,
    taskPaneState,
    filterTypeByCriteriaType,
    setPoliciesDetailsForInsured,
    setTaskPaneState,
    setSelectedGridItem,
    getLocationSpecificInfo
  } = useTaskPane();
  const { Toaster, notify } = useToast();
  const [open, setOpen] = useState(false);
const handleSearch = async () => {
    try {
      clearToaster();
      const result = await services.searchByCriteria(
        taskPaneState?.compId,
        taskPaneState?.comLocId,
        taskPaneState?.criteria,
        taskPaneState?.searchText,
        taskPaneState.userId
      );
      notify("success", "fetch successful!");
      if (filterTypeByCriteriaType === "Type Insured/Policy") {
        const policyList = result.srchPolicyDeatilsResult?.map(x=> {
          return {
            ...x,
            policyID: x.sub
          }
        })
        setSelectedGridItem(result?.policyId?new Set([result.policyId])  : policyList?.length? new Set([policyList[0]?.policyID?? 0]) : []);
        setPoliciesDetailsForInsured(policyList);
        const insuredResult = result?.srchInsuredByPolicyNumberResult?.length
            ? result?.srchInsuredByPolicyNumberResult
            : result.srchInsuredByNameResult;
        setTaskPaneState((prev) => ({
          ...prev,
          insuredForRecentPoliciesResults: insuredResult,
          insuredId: result?.insuredId? result?.insuredId : insuredResult?.length? insuredResult[0]?.insuredID : "",
          isSearch: true,
        }));
        if(!insuredResult?.length && !result?.srchPolicyDeatilsResult?.length) {
          setOpen(true);
          setTaskPaneState((prev) => ({
          ...prev,
          isSearch: false,
        }));
        }
      } else if (filterTypeByCriteriaType === "Type Producer") {
        const policyList = result.srchProducerResult?.map(x=> {
          return {
            ...x,
            policyID: x.producerId
          }
        })
        setSelectedGridItem(!!result?.producerId? new Set([result.producerId]) : policyList?.length? new Set([policyList[0]?.policyID?? 0]) : []);
        setPoliciesDetailsForInsured(policyList);
        if(!policyList?.length) {
            setOpen(true);
        }
      } else {
        setPoliciesDetailsForInsured([]);
      }
    } catch (e) {
      notify("error", "fetch failed!");
      appInsights.trackDependencyData({
              target: process.env.BASE_URL,
              name: "Excel_searchByCriteria_Payload",
              dependencyTypeName: "HTTPS",
              success: false,
              responseCode: e?.status || 500,
              properties: {
                bodyData: {
                  compId: taskPaneState?.compId,
                  comLocId: taskPaneState?.comLocId,
                  criteria: taskPaneState?.criteria,
                  searchText: taskPaneState?.searchText,
                  userId: taskPaneState.userId
                },
                error: e,
                userId: taskPaneState.userId
              }
            });
      console.log(e);
    }
  };
  const handleGetRecent = async () => {
    try {
      clearToaster();
      // const result = await services.getRecentInsured(taskPaneState?.compId, taskPaneState.userId);
      // notify("success", "fetch successful!");
      // setTaskPaneState((prev) => ({
      //   ...prev,
      //   insuredForRecentPoliciesResults: result,
      // }));
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
        setTaskPaneState((prev) => ({ ...prev, searchText: "" }));
        getLocationSpecificInfo(taskPaneState.compLocId, taskPaneState.compId);
    } catch (e) {
      // notify("error", "fetch failed!");
      console.log(e);
    }
  };
  return (
<>
      {Toaster}
       {open && 
       <AlertPopup 
       title="Search Failed" 
       text="Your search request returned no records. Please re-type your search text and try again." 
       open={open} 
       handleClose = {()=> setOpen(false)}/>}

          <div className="gap-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2">
           <div className="items-center gap-2 w-full flex flex-row seltest">
                           <label className="h3-text  text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-[4rem]">Location</label>
                          <select 
                              value={taskPaneState.comLocId}
                              onChange={(e) => updateState("comLocId", e.target.value)}
                              disabled={!locationData?.length}
                              defaultValue={""}
                              className=" mr-12 sm:mr-0 decorated input-layout rounded py-0 px-0 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
                          >
                             <div className="max-h-72 overflow-scroll">
                             {locationData?.length !== 1 && <option key={"none"} value={""}>
                                  {"Select Location"}
                              </option>}
                              
                              {locationData.map((l) => {
                                  return (
                                      
                                      <option key={l.compLocID} value={l.compLocID}>
                                          {l.companyLocation}
                                      </option>
                                      
                                  );
                              })}
                              </div>
                          </select>
                      </div>
                      <div className="absolute right-5">{appVersion}</div>
                  </div>
          <h2 className="h2-text text-left text-base font-semibold text-black-700 mb-1">
        Insured / Policy Information
      </h2>
      <h2 className="h3-text text-left text-base font-semibold text-gray-700 mb-1">Search Criteria</h2>
          {/* <div className="container"> */}
        <div className="gap-2 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3">
          {/* <div className="w-auto"> */}
          {/* </div> */}
          {/* <div className="w-auto mb-0"> */}
                      <Field className="items-center gap-2 w-full flex flex-column">
                           <select
              value={taskPaneState.criteria}
                onChange={(e) => updateState("criteria", e.target.value)}
                              disabled={!taskPaneState?.criteriaItems?.length}
                                                            className="input-layout rounded py-0 px-0 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
              >
                {/*<option value=""> Select criteria </option>*/}
                {taskPaneState?.criteriaItems?.map((criteria) => (
                  <option key={criteria.criteriaName} value={criteria.criteriaName}>
                    {criteria.criteriaName}
                  </option>
                ))}
              </select>
            </Field>
          {/* </div> */}
          {/* <div className="w-auto mt-0"> */}
            <Field className="items-center gap-2 w-full flex flex-column">
           <input
              value={taskPaneState.searchText}
              onChange={(e) => updateState("searchText", e.target.value)}
              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (taskPaneState?.searchText && !!taskPaneState?.searchText?.trim())
                                        handleSearch();
                                }
                            }}
              placeholder="Enter search term"
              className="input-layout rounded py-1 px-2 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
            ></input>
          </Field>
        {/* </div> */}
                <div className="gap-2 w-full flex flex-row items-end justify-flex-start">
          <Button
            
            onClick={handleSearch}
                      className={`${(!taskPaneState?.searchText || taskPaneState?.searchText?.trim() == "" || !taskPaneState?.comLocId)? "btn-com-disable": "btn-com"}`}
                      appearance="primary"
                      disabled={!taskPaneState?.searchText || taskPaneState?.searchText?.trim() == "" || !taskPaneState?.comLocId}
          >
            Search
          </Button>
          { (
            <Button
              onClick={handleGetRecent}
               appearance="primary"
              className={`${(!taskPaneState?.compId || filterTypeByCriteriaType !== "Type Insured/Policy")? "btn-com-disable": "btn-com"}`}
              disabled={!taskPaneState?.compId || filterTypeByCriteriaType !== "Type Insured/Policy"}
              
            >
              Get Recent
            </Button>
          )}
        </div>
        </div>
       {/* </div> */}
        {/* <div className="mb-2 grid grid-cols-1 gap-4 sm:grid-cols-1 sm:gap-4 md:grid-cols-2 md:gap-3 lg:gap-2 xl:grid-cols-3 ">
      </div> */}
    </>
  );
};

export default SearchCriteria;
